

































import { Component, Prop, VModel, Vue } from 'vue-property-decorator';
import moment from "moment/moment";
import CommonInputMixin from "@/components/new_style_components/mixins/CommonInputMixin.vue";

@Component<PortalDate>({
  inheritAttrs: false,
  mixins: [CommonInputMixin],
})
export default class PortalDate extends Vue {
	@VModel({ type: String })
	private inputValue!: string;

	@Prop({ default: "date" })
	private type!: "date" | "datetime-local" | "week" | "time";

	@Prop({ default: null })
	private change!: (val: string) => void | null

  @Prop({default: ''})
  private validatePattern!: string;

	public created(): void {
		this.$validator.remove("date_format")
		this.$validator.extend("date_format", {
			validate: (value: string) => {
				switch (this.type) {
					case "date":
						return moment(value, "YYYY-MM-DD").isValid()
					case "datetime-local":
						return moment(value, "YYYY-MM-DDTHH:mm:ss").isValid()
					case "time":
						return moment(value, "HH:mm").isValid()
					default: return true
				}
			},
			getMessage: (field, params, data) => "Invalid date format"
		})
	}

  get isRequired(): boolean {
    return this.validatePattern?.includes("required");
  }
}
